import { Dialog } from "@mui/material";
import { type ReactNode } from "react";

import AppLoader from "@/components/molecules/AppLoader";
import AppDialog from "@/components/sitehub-ui/atoms/AppDialog";
import { AppDialogStore } from "@/stores/app-dialog-store";
import { AppLoadingStore } from "@/stores/app-loading-store";
import { useObservable } from "@/utils/hook";
import { useSentryContext } from "@/utils/sentry/use-sentry-context";

export function AppProvider(props: { children?: ReactNode }) {
  useSentryContext();

  const [isLoading] = useObservable(AppLoadingStore.getInstance().observable);
  const [dialogProps] = useObservable(AppDialogStore.getInstance().observable);

  return (
    <>
      {props.children}
      <Dialog
        open={!!isLoading}
        PaperProps={{
          elevation: 15,
          style: {
            backgroundColor: "transparent",
            borderRadius: "106px / 48px"
          }
        }}
      >
        <AppLoader />
      </Dialog>
      <AppDialog
        open={!!dialogProps?.shown}
        onClose={dialogProps?.onClose}
        aria-labelledby={dialogProps?.ariaLabelledBy}
        aria-modal={dialogProps?.ariaModal ?? true}
        autoFocus={dialogProps?.autoFocus ?? true}
      >
        {dialogProps?.children}
      </AppDialog>
    </>
  );
}
